import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_dashboard/graylog/')({
	beforeLoad: () => {
		throw redirect({ to: '/graylog/alerts' })
	},
	head: () => ({
		meta: [
			{
				title: 'Graylog | BitLyft AIR®',
			},
		],
	}),
})
